import { decamelizeKeys } from "humps";
import api from "PFCore/api";
import { camelizeDesiredKeys, decamelizeDesiredKeys } from "PFCore/helpers/keys_camelization_utils";
import { getRootDomain } from "PFCore/helpers/root_domain";
import { CurrentAccount, Id, MyAccountInfo, Snakify } from "PFTypes";

export const fetchAccount = (domain: Id): Promise<Snakify<CurrentAccount>> =>
  api({
    url: `accounts/${domain}`
  });

export const fetchMyAccountInfo = () =>
  api({
    url: "my_account_info"
  })
    .then((response) =>
      decamelizeDesiredKeys<MyAccountInfo>(response, ["templates", "customTypes", "availability"])
    )
    .catch((error) => {
      if (error?.response?.status === 404) {
        console.info("My account info called before sign in");
        // Should not happen, but we don't want to crash the app, also solves the issue with storybook
        return {} as MyAccountInfo;
      }
      throw error;
    });

export const fetchCurrentAccount = (): Promise<CurrentAccount> =>
  fetchAccount(getRootDomain())
    // TODO: [SP-2590] When we switch to using camelCase account attributes
    // we need to add `camelizeKeys` here manually
    // because `setupAxiosInstance` is done after account is initially fetched
    .then((response) => decamelizeKeys(response) as CurrentAccount)
    .then(
      (response) =>
        camelizeDesiredKeys(response as Record<string, unknown>, [
          "customization",
          "client_codename"
        ]) as CurrentAccount
    );

export const exportAccountConfig = (accountId: number) =>
  api({
    url: `accounts/${accountId}/export`,
    skipCamelization: true
  });

export const importAccountConfig = (accountId: number, data): Promise<void> =>
  api({
    method: "POST",
    url: `accounts/${accountId}/import`,
    data
  });

export const fetchCvParserConfig = (accountId: Id) => api({ url: `accounts/${accountId}/cv_parser_config` });

export const updateCvParsingConfig = (accountId: Id, data) =>
  api({ url: `accounts/${accountId}/cv_parser_config`, method: "PUT", data });
